<template>
  <section class="c-section c-section--specialist">
    <div class="c-banner-specialist pt-5">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-12 col-lg-6 d-none d-lg-block">
            <div class="c-banner-specialist__container">
              <figure class="c-banner-specialist__figure">
                <img :src="`${context.banner.image.url}`" alt="" class="w-100 h-100 of--cover">
              </figure>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="py-5 px-lg-5" v-if="context.banner">
              <h2 class="fs-35 w-sbold sec-medium mb-4">
                {{context.banner.title}}
              </h2>
              <p class="fs-21 sec-medium w-light mb-4">
                {{context.banner.description}}
              </p>
              <router-link
                to="/especialistas-contacto"
                class="c-button c-button--primary d-inline-block"
              >
                Comunicate con nosotros
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white pt-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-6">
            <h2 class="fs-35 sec-medium w-sbold text-center" v-if="context.specialists_title">
              {{context.specialists_title}}
            </h2>
            <p
              class="text-center sec-medium w-regular fs-21 mb-5"
              v-if="context.specialists_description"
            >
              {{context.specialists_description}}
            </p>
          </div>
        </div>
        <div class="row justify-content-center gy-4">
          <div
            v-for="specialist of context.specialists"
            :key="`specialist-${specialist.id}`"
            class="col-12 col-md-6 col-lg-4"
          >
            <SpecialistCard class="c-specialyst-card--dark" :body="specialist" />
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white py-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-6">
            <div class="c-testimonials">
              <div class="c-testimonials__text py-5">
                <h2 class="fs-55 sec-medium w-light" v-if="context.testimonies_title">
                  {{context.testimonies_title}}
                </h2>
                <p class="fs-18 w-regular sec-dark" v-if="context.testimonies_description">
                  {{context.testimonies_description}}
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="c-history-company">
              <figure class="c-history-company__figure mb-4">
                <img
                  :src="testimonyFirst.brand ? testimonyFirst.brand.url : ''"
                  :alt="testimonyFirst.author ? testimonyFirst.author.fullname : ''"
                  class="h-100 of--cover"
                />
              </figure>
              <div class="c-history-company__grilla">
                <p class="c-history-company__text ps-4" v-html="testimonyFirst.content"></p>
              </div>
              <h2 class="fs-18 sec-dark w-bold ps-4">
                {{testimonyFirst.author ? testimonyFirst.author.fullname : ''}}
              </h2>
              <p class="fs-14 w-medium gray-sdark ps-4">
                {{testimonyFirst.author ? testimonyFirst.author.job : ''}}
              </p>
            </div>
          </div>
          <div
            v-for="(testimony, itestimony) of testimoniesExtra"
            :key="`testimony-${itestimony}`"
            class="col-12 col-lg-4"
          >
            <div class="c-history-company">
              <figure class="c-history-company__figure mb-4">
                <img
                  :src="testimony.brand ? testimony.brand.url : ''"
                  :alt="testimony.author ? testimony.author.fullname : ''"
                  class="h-100 of--cover"
                />
              </figure>
              <div class="c-history-company__grilla">
                <p class="c-history-company__text ps-4" v-html="testimony.content"></p>
              </div>
              <h2 class="fs-18 sec-dark w-bold ps-4">
                {{testimony.author ? testimony.author.fullname : ''}}
              </h2>
              <p class="fs-14 w-medium gray-sdark ps-4">
                {{testimony.author ? testimony.author.job : ''}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      context: {},
      contextLoading: true,
    };
  },
  created() {
    this.getFullContext({ type: 'page', slug: 'especialistas' });
  },
  computed: {
    testimonyFirst() {
      return this.context.testimonies
        ? this.context.testimonies[0]
        : false;
    },
    testimoniesExtra() {
      return this.context.testimonies
        ? this.context.testimonies.filter((co, ico) => ico !== 0)
        : [];
    },
  },
  components: {
    SpecialistCard: () => import(/* webpackChunkName: "specialist-card" */'../../components/SpecialistCard.vue'),
  },
};
</script>
